// Class strings shared by the customers screens (dashboard tokens: rounded-[14px]
// cards on gray-200 borders, 44px controls, indigo accent).
export const buttonClass = {
  primary:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] bg-indigo-600 px-[18px] text-sm font-semibold text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50",
  secondary:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
  // Destructive, outside a confirm dialog: outlined only.
  dangerOutline:
    "inline-flex min-h-10 items-center justify-center gap-1.5 rounded-lg border border-red-200 bg-white px-3.5 text-sm font-semibold text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50",
  // Destructive, the confirming button inside a confirm dialog only.
  danger:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] bg-red-700 px-[18px] text-sm font-semibold text-white hover:bg-red-800 disabled:cursor-not-allowed disabled:opacity-50",
  small:
    "inline-flex min-h-10 items-center justify-center rounded-lg border border-gray-300 bg-white px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
};

export const inputClass =
  "block min-h-11 w-full rounded-[10px] border border-gray-300 px-3 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-indigo-500";

export const labelClass = "flex flex-col gap-1.5 text-[13px] font-semibold text-gray-700";

export const cardClass = "rounded-[14px] border border-gray-200 bg-white";

// Rounded filter chip: dark when on.
export function chipClass(on) {
  return `inline-flex min-h-9 items-center gap-1.5 rounded-full border px-3 text-[13px] font-medium whitespace-nowrap ${
    on
      ? "border-gray-900 bg-gray-900 text-white"
      : "border-gray-300 bg-white text-gray-700 hover:border-gray-400"
  }`;
}
